import React, { ReactNode } from 'react';

import { Box, Skeleton, Typography } from '@mui/material';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';

interface TextBlockProps {
    title: ReactNode;
    data: ReactNode;
    flexRight?: boolean;
    isLoading?: boolean;
    blockName?: string;
}

const TextBlock = ({
    title,
    data,
    flexRight = false,
    isLoading = false,
    blockName,
}: TextBlockProps) => {
    const { theme } = useTheme();
    const flexRightProps = {
        justifyContent: 'flex-end',
        ml: 'auto',
    };

    return (
        <Box
            display="flex"
            {...(flexRight && flexRightProps)}
            data-testid={`text-block-${blockName}`}>
            <Box display="flex" flexDirection="column">
                {isLoading ? (
                    <Skeleton
                        width={150}
                        data-testid={`${blockName}-title-skeleton`}
                    />
                ) : (
                    <Typography
                        variant="overline"
                        textAlign={flexRight ? 'end' : 'start'}>
                        {title}
                    </Typography>
                )}
                {isLoading ? (
                    <Skeleton
                        width={150}
                        data-testid={`${blockName}-data-skeleton`}
                    />
                ) : (
                    <Typography
                        variant="h4"
                        textAlign={flexRight ? 'end' : 'start'}
                        color={
                            theme.custom.brand.textMain ||
                            theme.palette.primary.main
                        }>
                        {data}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default TextBlock;
